const BITCOIN_MILADYS_CONTRACT = '0x8182b2010f98fcb4a89738090ed25622780a2452'

/** Resolve artwork using the Ethereum token id recorded in the inscription. */
export function getBrc721eImageUrl(data: unknown): string | null {
	if (!data || typeof data !== 'object') return null
	const { p, contract, token_id } = data as Record<string, unknown>
	if (p !== 'brc-721e' || typeof contract !== 'string' || contract.toLowerCase() !== BITCOIN_MILADYS_CONTRACT) return null
	if (typeof token_id !== 'string' || !/^\d{1,5}$/.test(token_id)) return null
	const id = Number(token_id)
	if (id >= 10_000) return null
	// The collection's mint platform caches its original IPFS artwork. The old
	// preview service depends on an unavailable RPC and retired IPFS gateways.
	return `https://www.scatter.art/api/nft/qk6aqc3n41rgg203p3lte3d2/${id}/image`
}
